/****
 * Centralized responsive design breakpoint configuration.
 *
 * Defines the screen width thresholds used throughout the application
 * to identify mobile, tablet, and desktop devices. These values help
 * maintain consistent responsive behavior across layouts, components,
 * and UI rendering logic.
 */
export const breakpoints = {
  mobileMax: 640,
  tabletMin: 641,
  tabletMax: 1024,
  desktopMin: 1025,
};
